// Auth route — Login (US-004).
//
// Wave 4.2 wires the real `LoginPage` from `features/auth`. The route file
// owns route metadata only; the component body lives with the rest of the
// auth feature so it can be unit-tested without a router fixture.

import { createRoute } from '@tanstack/react-router';

import { LoginPage } from '@/features/auth/LoginPage';

import { Route as RootRoute } from '../__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/login',
  validateSearch: (search): { from?: string; reset?: '1' } => ({
    from: typeof search.from === 'string' ? search.from : undefined,
    reset: search.reset === '1' ? '1' : undefined,
  }),
  component: LoginPage,
});
